import React, { FC } from 'react';
import { CoreButtonBase, CoreButtonBaseProps, CoreButtonVariant } from './core-button-base.component';
import { FadeSpinner } from '../fade-spinner';
import { Theme, Tooltip, useTheme } from '@mui/material';
import { CoreCircleButton, CoreCircleButtonProps } from './core-circle-button.component';

type DefaultButtonType = CoreButtonBaseProps & { circle?: false };
type CircleButtonType = CoreCircleButtonProps & { circle: true };

export type CoreButtonProps = (DefaultButtonType | CircleButtonType) & { loading?: boolean, tooltipTitle?: string };

export const CoreButton: FC<CoreButtonProps> = (props) => {
	const { loading, circle, disabled, children, tooltipTitle, ...buttonProps } = props;

	const theme = useTheme();

	let spinnerColor;

	switch (buttonProps.variant) {
		case 'danger':
			spinnerColor = theme.colors.red;
			break;
		case 'primary':
			spinnerColor = theme.colors.orangeDeep;
			break;
		case 'secondary':
			spinnerColor = theme.colors.darkGray;
			break;
		case 'info':
			spinnerColor = theme.colors.blue;
			break;
		case 'info-light':
			spinnerColor = theme.colors.lightBlue;
			break;
		case 'base':
			spinnerColor = theme.colors.lightBlue;
			break;
	}

	const Component = circle ? CoreCircleButton : CoreButtonBase;
	const size = circle ? props.size : undefined;
	const hideChildren = loading && circle;

	return (
		<Tooltip title={tooltipTitle} >
		<Component
			{...buttonProps}
			size={size}
			disabled={loading || disabled}
			className={loading ? 'core-button-loading' : undefined}
		>
			{loading && (
				<FadeSpinner
					size={17}
					height={5}
					width={2}
					borderRadius={1}
					color={spinnerColor}
					sx={{ marginRight: circle ? 0 : '10px' }}
				/>
			)}
			{!hideChildren && children}
		</Component>
		</Tooltip>
	);
};
